import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NameSectionForm from '../../../../../ReusableFormSections/NameSection/NameSectionForm'

import { selectedDV360AdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { clearUpdateAd, updateAd } from '../../../../../../modules/actions/ads'
import {
  adUpdateErrorSelector,
  adUpdateIsLoadingSelector,
  adWasUpdatedSelector
} from '../../../../../../modules/selectors/ads'
import { DV_360_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

const NameSection = ({ editItemData: ad, isInternalAd, title, ...formProps }) => {
  const dispatch = useDispatch()

  const adWasUpdated = useSelector(adWasUpdatedSelector)
  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const { account: adAccountId } = ad
  const adAccount = adAccountId || selectedAdAccountId

  const handleSubmit = useCallback(
    values => {
      const updatedAdData = {
        account: adAccount,
        ...values,
        ...(isInternalAd && { internal: true }),
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        }
      }

      dispatch(updateAd(updatedAdData, ad.id, DV_360_PLATFORM))
    },
    [dispatch, ad.id, adAccount, isInternalAd, title]
  )

  const handleClearUpdateAd = useCallback(() => {
    dispatch(clearUpdateAd())
  }, [dispatch])

  return (
    <NameSectionForm
      placeholder="Ad Name"
      editItem={ad}
      handleSubmit={handleSubmit}
      clearEditItem={handleClearUpdateAd}
      successSubmit={adWasUpdated}
      isLoadingSelector={adUpdateIsLoadingSelector}
      errorSelector={adUpdateErrorSelector}
      {...formProps}
    />
  )
}

export default NameSection
